import React from 'react';
import PropTypes from 'prop-types';
import { Typeahead } from 'react-bootstrap-typeahead';

import StatusError from '@telus-uds/palette-allium/build/web/icons/StatusError';
import Label from './common/label';
import { storeCodeOutletMapping, storeCodes } from '../constant';

const StoreCode = ({ labels, errors, touched, values, setFieldValue }) => {
  const getMappedOutletId = storeCodeValue => {
    return storeCodeOutletMapping[storeCodeValue] || null;
  };

  return (
    <>
      <Label labelName={labels.STORE_CODE} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.storeCode && touched.storeCode ? 'error' : ''
        }`}
      >
        <Typeahead
          id="storeCode"
          labelKey="label"
          options={storeCodes}
          onChange={selected => {
            const selectedCode = selected[0] || '';
            setFieldValue('storeCode', selectedCode);
            const mappedOutlet = getMappedOutletId(selectedCode);
            if (mappedOutlet) {
              setFieldValue('outlet', mappedOutlet);
            }
          }}
          placeholder={labels.PLACEHOLDER_STORE_CODE}
          selected={values.storeCode ? [values.storeCode] : []}
          clearButton
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.storeCode}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <StatusError size={16} color="#C12335" aria-hidden="true" />
          </div>
        </>
      </div>
    </>
  );
};

StoreCode.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  values: PropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

export default StoreCode;
